import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Item = styled(Link)`
  position: relative;
  border-radius: var(--double-unit);
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  justify-content: flex-start;
  &:not(a) {
    cursor: not-allowed;
  }
  & {
    &:hover,
    &:focus {
      filter: brightness(1.1);
      color: inherit;
    }
  }
  overflow: hidden;

  --background-color: var(--c-neutral-200);
  --gradient: linear-gradient(
    0deg,
    var(--c-neutral-200) 5.05%,
    rgba(var(--c-rgb-neutral-200), 0.9) 30.91%,
    rgba(var(--c-rgb-neutral-200), 0) 64.17%
  );
  @media ${tabletAndAbove} {
    gap: var(--quadruple-unit);
  }
`;

export const GameMode = styled(Item)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1.3;
  @media ${tabletAndAbove} {
    aspect-ratio: 1.1;
  }
  max-height: 800px;
`;
